/* eslint-disable prettier/prettier */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  IconButton,
  Input,
} from '@material-ui/core';
import { PhotoCamera, Delete } from '@material-ui/icons';

const StationImageModal = ({ 
  open, 
  onClose, 
  stations, 
  currentStation, 
  remainingCount, 
  onCancel, 
  onImageSelect 
}) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setSelectedImage({
          file,
          preview: e.target.result,
          name: file.name
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setSelectedImage(null);
  };

  const handleConfirm = () => {
    if (selectedImage && currentStation) {
      onImageSelect(currentStation.id, selectedImage.file);
      setSelectedImage(null);
    }
  };

  const handleCancel = () => {
    setSelectedImage(null);
    onCancel && onCancel();
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleCancel}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        {currentStation ? `Selecionar Imagem - ${currentStation.title}` : 'Selecionar Imagem'}
        {remainingCount > 0 && (
          <Typography variant="caption" display="block" color="textSecondary">
            {remainingCount} estação(ões) restante(s)
          </Typography>
        )}
      </DialogTitle>
      
      <DialogContent>
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
          Selecione uma imagem para a estação {currentStation?.title}:
        </Typography>
        
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card variant="outlined">
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  {currentStation?.title || 'Estação'}
                </Typography>
                
                {selectedImage ? (
                  <Box>
                    <CardMedia
                      component="img"
                      height="200"
                      image={selectedImage.preview}
                      alt={`Imagem para ${currentStation?.title}`}
                      style={{ 
                        objectFit: 'cover',
                        borderRadius: 4,
                        marginBottom: 8
                      }}
                    />
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                      <Typography variant="caption" color="textSecondary">
                        {selectedImage.name}
                      </Typography>
                      <IconButton 
                        size="small" 
                        onClick={handleRemoveImage}
                        color="secondary"
                      >
                        <Delete />
                      </IconButton>
                    </Box>
                  </Box>
                ) : (
                  <Box 
                    display="flex" 
                    flexDirection="column" 
                    alignItems="center" 
                    justifyContent="center"
                    style={{
                      height: 200,
                      border: '2px dashed #ccc',
                      borderRadius: 4,
                      cursor: 'pointer'
                    }}
                  >
                    <input
                      accept="image/*"
                      style={{ display: 'none' }}
                      id="image-upload-input"
                      type="file"
                      onChange={handleImageUpload}
                    />
                    <label htmlFor="image-upload-input">
                      <IconButton color="primary" component="span">
                        <PhotoCamera />
                      </IconButton>
                    </label>
                    <Typography variant="caption" color="textSecondary">
                      Clique para selecionar uma imagem
                    </Typography>
                  </Box>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </DialogContent>
      
      <DialogActions>
        <Button onClick={handleCancel} color="secondary">
          Cancelar
        </Button>
        <Button 
          onClick={handleConfirm} 
          color="primary" 
          variant="contained"
          disabled={!selectedImage}
        >
          Confirmar Imagem
        </Button>
      </DialogActions>
    </Dialog>
  );
};

StationImageModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  stations: PropTypes.array,
  currentStation: PropTypes.object,
  remainingCount: PropTypes.number,
  onCancel: PropTypes.func,
  onImageSelect: PropTypes.func.isRequired,
};

export default StationImageModal;
